// Authentication API Service

import { api, ApiError } from './api';

// Request types
export interface RegisterRequest {
  email: string;
  password: string;
  confirmPassword: string;
  name: string;
  languagePreference?: string;
  timezone?: string;
}

export interface LoginRequest {
  email: string;
  password: string;
}

export interface RefreshTokenRequest {
  refreshToken: string;
}

// Response types
export interface AuthResponse {
  accessToken: string;
  refreshToken: string;
  expiresAt: string;
  userId: string;
  email: string;
}

// User type for validation response
export interface UserDto {
  id: string;
  email: string;
  name?: string;
  profileImageUrl?: string;
  languagePreference?: string;
  timezone?: string;
}

// Auth API functions
export const authApi = {
  async register(data: RegisterRequest): Promise<AuthResponse> {
    return api.post<AuthResponse>('/auth/register', data);
  },

  async login(data: LoginRequest): Promise<AuthResponse> {
    return api.post<AuthResponse>('/auth/login', data);
  },

  async refresh(data: RefreshTokenRequest): Promise<AuthResponse> {
    return api.post<AuthResponse>('/auth/refresh', data);
  },

  async logout(): Promise<void> {
    return api.post('/auth/logout');
  },

  // Validate the current token by fetching user profile
  async validateToken(): Promise<UserDto> {
    return api.get<UserDto>('/users/me');
  },
};

export { ApiError };
